module.exports = __webpack_public_path__ + "static/media/user.3a6feb73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.svg
// module id = 917
// module chunks = 7